import { render, staticRenderFns } from "./PlatformBottomBar.vue?vue&type=template&id=4c247ce8&scoped=true"
import script from "./PlatformBottomBar.vue?vue&type=script&lang=js"
export * from "./PlatformBottomBar.vue?vue&type=script&lang=js"
import style0 from "./PlatformBottomBar.vue?vue&type=style&index=0&id=4c247ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c247ce8",
  null
  
)

export default component.exports